export default __webpack_public_path__ + "static/global_flag-27f08f46a172514fffb41cf62f5990f8.png";